import { SentryError } from '@ifixit/sentry';
import { _js } from '@ifixit/localize';
import { Fragment } from 'react';
import { MinimalDisclosure } from 'Guide/Schematics/Diagram/Logic/minimalDisclosure';
import { LoadingModal, renderErrorToUser, OkButton, MainText, SubText } from './basicModal';
import { THDFetchFunc, THDFetchProps } from './thdApiModal';
import { getWorkOrder, getWorkOrderIncident } from './thdWorkOrder';
import { iFixitHotSpotItem } from '../Generic/iFixitHotSpotItem';

const renderResponse = (data: any, onClose: MinimalDisclosure['onClose']) => (
   <PartFound json={data.json} onClose={onClose} />
);

const PartFound = ({ onClose, json }: { onClose: MinimalDisclosure['onClose']; json: any }) => (
   <Fragment>
      <MainText>{_js('Part Added!')}</MainText>
      <SubText>{json.statusMessage}</SubText>
      <OkButton onClose={onClose} />
   </Fragment>
);

const HDESModal = ({
   fetchFn,
   isOpen,
   onClose,
}: { fetchFn?: THDFetchFunc } & MinimalDisclosure) => (
   <LoadingModal
      // @ts-expect-error TS(2322) FIXME: Type '({ apiUrl, apiKey, createdUserId, item, }: {... Remove this comment to see the full error message
      fetchFn={fetchFn || fetchOrderPartApiResult}
      // @ts-expect-error TS(2322) FIXME: Type '({ fetchFn, ...props }: { fetchFn?: THDFetch... Remove this comment to see the full error message
      promiseFn={orderPart}
      onLoading={() => _js('Loading...')}
      onError={renderErrorToUser}
      onSuccess={renderResponse}
      isOpen={isOpen}
      onClose={onClose}
   />
);

const orderPart = async ({ fetchFn, ...props }: { fetchFn?: THDFetchFunc } & THDFetchProps) => {
   // @ts-expect-error TS(2722) FIXME: Cannot invoke an object which is possibly 'undefin... Remove this comment to see the full error message
   const response = await fetchFn(props);
   if (!response.ok) {
      await throwFetchError(response);
   }

   const result = await response.json();
   if (!result) {
      throw new SentryError('No json returned from THD API');
   }

   return {
      status: response.status,
      json: result,
   };
};

const throwFetchError = async (response: Response) => {
   if (response.ok) {
      return;
   }

   const result = await response
      .json()
      .catch((_error: Error) => ({ errorMessage: response.statusText }));

   const message = result.detail;

   throw new FetchError(message, result);
};

const fetchOrderPartApiResult = ({
   apiUrl,
   apiKey,
   createdUserId,
   item,
}: {
   apiUrl: string;
   apiKey: string;
   createdUserId: string;
   item: iFixitHotSpotItem;
}) => {
   const body = {
      workOrderNumber: getWorkOrder(),
      workOrderIncidentNumber: getWorkOrderIncident(),
      partNumber: item.wiki?.sku || '',
      createdUserId,
   };

   const headers = {
      Accept: '*/*',
      'thd-ifixit-key': apiKey,
      'Content-Type': 'application/json',
   };

   return fetch(apiUrl, {
      method: 'POST',
      body: JSON.stringify(body),
      headers,
      credentials: 'include',
   });
};

class FetchError extends Error {
   data: any;
   constructor(message: string, data: any) {
      super(message);
      this.data = data;
   }
}

export default HDESModal;
